import type { OverviewResponse } from "contracts/api/dashboard/responses";
import type { Issue } from "contracts/api/issue/responses";
import { evidenceTextIdentity } from "./boundaries/evidence-text.parser";
import { linkEvidence, presentEvidence } from "./evidencePresentation";
import {
  type CurrentIssuePageGroup,
  currentIssuePageGroups,
} from "./issuePageResolution";
import { siteSpecificText } from "./issueSiteText";

type CurrentPageReadableEvidence = {
  pageId: string;
  path: string;
  value: string;
};

export function currentPageReadableEvidenceForIssue(
  data: OverviewResponse,
  issue: Issue,
): CurrentPageReadableEvidence[] {
  return currentIssuePageGroups(data, issue).flatMap((group) =>
    currentPageEvidenceForGroup(data, group).readable.map((item) => ({
      pageId: group.page.id,
      path: group.page.path,
      value: item.value,
    })),
  );
}

export function currentPageEvidenceForGroup(
  data: OverviewResponse,
  group: CurrentIssuePageGroup,
) {
  const seenReadable = new Set<string>();
  const readable: ReturnType<typeof presentEvidence>["readable"] = [];
  const technical: ReturnType<typeof presentEvidence>["technical"] = [];
  for (const resolution of group.resolutions) {
    const presented = presentEvidence(
      linkEvidence(
        resolution.link,
        siteSpecificText(data, resolution.link.evidenceSnippet) !== null,
      ),
    );
    for (const item of presented.readable) {
      const key = evidenceTextIdentity(item.value);
      if (seenReadable.has(key)) continue;
      seenReadable.add(key);
      readable.push(item);
    }
    technical.push(...presented.technical);
  }
  return { readable, technical };
}
